import React from "react";
import { observer } from "mobx-react";
import { TadManagerConfigViewStore } from "../../store";
import { TadManagerConfigViewForm } from "./TadManagerConfigViewForm";
import { ErrorDialog } from "../../../../common/controls";

export type TadManagerConfigViewProps = {
  tadManagerConfigViewStore: TadManagerConfigViewStore;
};

export const TadManagerConfigView: React.FC<TadManagerConfigViewProps> =
  observer(({ tadManagerConfigViewStore }) => {
    return (
      <div>
        <TadManagerConfigViewForm
          authProviderOptions={tadManagerConfigViewStore.getAuthProviderOptions()}
          authProvider={tadManagerConfigViewStore.authProviderValue}
          idCardTypeOptions={tadManagerConfigViewStore.getIdCardTypeOptions()}
          idCardType={tadManagerConfigViewStore.idCardTypeValue}
          idCard={tadManagerConfigViewStore.idCardValue}
          genderOptions={tadManagerConfigViewStore.getGenderOptions()}
          gender={tadManagerConfigViewStore.genderValue}
          onPrint={(handlePrint: () => void) =>
            tadManagerConfigViewStore.printTadManagerConfig(handlePrint)
          }
          onCancel={() => tadManagerConfigViewStore.cancelTadManagerConfig()}
          onEdit={
            tadManagerConfigViewStore.isEditEnabled
              ? () => tadManagerConfigViewStore.editTadManagerConfig()
              : undefined
          }
        />
        <ErrorDialog
          open={tadManagerConfigViewStore.errorDialogOpened}
          title={tadManagerConfigViewStore.errorTitle}
          description={tadManagerConfigViewStore.errorDescription}
          onClose={() => tadManagerConfigViewStore.closeErrorDialog()}
        />
      </div>
    );
  });
